export default "/_next/static/images/35969b385c78314c6782e9426869049d.png";